// Vue Router
import Vue from "vue";
import VueRouter from "vue-router";
// routers
import {
  // loginRoutes,
  homeRoutes,
  notFoundRoutes,
  appRoutes,
  permissionsRoutes,
  buildModuleRoutePath
} from "@/router/solution/solutionRoutes";

import { cityCenterRoutes } from "@/router/cityCenter/cityCenterRoutes";
import { routeNames } from "./solution/solutionRoutes";
// services
import {
  applicationName as application,
  applicationTitle
} from "@/services/solution/solutionService";
// utils
// import { getLocalStorageItem } from "@/utils/localStorageUtility";
import {
  getLoggedInInfo,
  getUnConstructedPermissions
} from "@/services/cityCenter/login/loginService";
import { pascalToHyphen } from "@/utils";
import { routeName as cityCenterRoute } from "@/services/cityCenter/cityCenterService";

Vue.use(VueRouter);

console.log("process.env.BASE_URL", process.env.BASE_URL);

const router = new VueRouter({
  // history mode: leverages the history.pushState API to achieve URL navigation without a page reload
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // ...loginRoutes,
    ...appRoutes,
    ...permissionsRoutes,
    ...homeRoutes,
    ...cityCenterRoutes,
    ...notFoundRoutes
  ]
});

//
// Using Global route Guards
//

router.beforeEach((to, from, next) => {
  const availableRoutes =
    JSON.parse(getUnConstructedPermissions())?.length > 0
      ? JSON.parse(getUnConstructedPermissions())
      : [];
  const loggedIn = getLoggedInInfo();
  const title = to.meta.title;
  // if the route being routed to has title defined in meta than create title for web page
  if (title) {
    document.title = createTitle(title);
  }
  // check if {to} route requires auth and user is logged in and available routes permissions list has any item.
  if (
    to.matched.some(route => route.meta["requiresAuth"]) &&
    loggedIn &&
    availableRoutes.length > 0
  ) {
    let canRoute = availableRoutes.some(route =>
      to.path.startsWith(`/${pascalToHyphen(route.name)}`)
    );
    if (to.path === `/${pascalToHyphen(routeNames.apps)}`) {
      canRoute = true;
    }
    // allow route
    if (pascalToHyphen(to.name) === pascalToHyphen(application.CityCenter)) {
      next({ path: buildModuleRoutePath(cityCenterRoute.Dashboard) });
    }
    // else {
    //   next();
    // }
    else if (canRoute) {
      next();
    } else {
      next({ name: routeNames.error404 });
    }
  }
  // if user is logged in and route has requireAuth as false or there is no item in available routes permissions list.
  else if (loggedIn) {
    // if route being routed to is of Permissions route than allow it
    if (to.path === `/${pascalToHyphen(routeNames.apps)}`) {
      next();
    } else if (to.path === `/${pascalToHyphen(routeNames.permissions)}`) {
      next();
    }
    // if route being routed to is "CityCenter" than check if available routes permissions list has any item
    // and if there are items than route to Dashboard else route to permissions route.
    else if (to.name === pascalToHyphen(application.CityCenter)) {
      if (availableRoutes.length > 0) {
        next({ path: buildModuleRoutePath(cityCenterRoute.Dashboard) });
      } else {
        next({
          path: `/${pascalToHyphen(routeNames.permissions)}`
        });
      }
    }
    // check if available routes permissions list has any item and allow the route and if not than route to permissions route.
    else {
      if (availableRoutes.length > 0) {
        next();
      } else {
        next({
          path: `/${pascalToHyphen(routeNames.permissions)}`
        });
      }
    }
  }
});
function createTitle(title) {
  return title.concat(" - ").concat(applicationTitle.CityCenter);
}
export default router;
